import { Stack, useMediaQuery, useTheme } from '@mui/material'
import AuthProvider from '../../../hooks/Providers/Auth'
import AuthGuard from '../AuthGuard'
import { AuthMainContainerProps } from './props'
import { DeltaCoreXLogoWhite } from '../../../assets/icons'
import { Link } from 'react-router'
import links from '../../../routes/links'

export default function AuthMainContainer(props: AuthMainContainerProps) {
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <AuthProvider>
      <AuthGuard>
        <Stack
          alignItems={'center'}
          justifyContent={upMd ? 'center' : 'start'}
          gap={2}
          sx={{ width: '100vw', height: '100vh', bgcolor: theme.palette.primary.main, p: upMd ? 4 : 2 }}
        >
          <Link to={links.public.home()}>
            <DeltaCoreXLogoWhite />
          </Link>
          {props.children}
        </Stack>
      </AuthGuard>
    </AuthProvider>
  )
}
